import { createContext, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials, clearCredentials } from "../store/slices/authSlice";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalView, setModalView] = useState("sign-in");

  const openModal = (view = "sign-in") => {
    setModalView(view);
    setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);

  const updateUser = (updatedUser) => {
    dispatch(setCredentials({ token, user: updatedUser }));
  };

  const logout = () => {
    dispatch(clearCredentials());
    closeModal();
  };

  return (
    <AuthContext.Provider
      value={{ user, token, modalOpen, modalView, openModal, closeModal, logout, setModalView, updateUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
